import dateTool from "./dateTool.js";
import FileSaver from "file-saver";
import XLSX from "xlsx";
import {
  MessageBox
} from 'element-ui';
export function getMain (obj) {
  if (obj.children.length > 0) {
    let item = getMain(obj.children[0]);
    return item;
  } else {
    return obj;
  }
}
/**
 * [获取URL中的参数名及参数值的集合]
 * 示例URL:http://htmlJsTest/getrequest.html?uid=admin&rid=1&fid=2&name=小明
 * @param {[string]} urlStr [当该参数不为空的时候，则解析该url中的参数集合]
 * @return {[string]}       [参数集合]
 */
export function getRequest (urlStr) {
  var url = "";
  if (typeof urlStr == "undefined") {
    url = decodeURI(location.search); //获取url中"?"符后的字符串
  } else {
    url = "?" + urlStr.split("?")[1];
  }
  var theRequest = new Object();
  if (url.indexOf("?") != -1) {
    var str = url.substr(1);
    var strs = [];
    strs = str.split("&");
    for (var i = 0; i < strs.length; i++) {
      theRequest[strs[i].split("=")[0]] = decodeURI(strs[i].split("=")[1]);
    }
  }
  return theRequest;
}

//判断是否为数字且不为空
export function isRealNum (val) {
  if (val === "" || val == null) {
    return false;
  }
  if (!isNaN(val)) {
    return true;
  } else {
    return false;
  }
}
/**
 * @msg: 获取系统当前时间
 * @param {string} date 时间
 * @param {string} fmt 时间格式
 * @return: string
 */
export const formatDate = (date, fmt) => {
  //因为ie11 不支持new Date('2020-10-11 00:00:00')所以先转化成 2020/10/11 00:00:00
  if (typeof (date) == "string") {
    let newStart = date.replace(/-/g, "/")
    date = newStart;

  }
  date = date || new Date();
  fmt = fmt || "yyyy-MM-dd hh:mm:ss";
  let newPattern = fmt.replace(/-/g, "/")
  fmt = newPattern;
  if (Object.prototype.toString.call(date).slice(8, -1) !== "Date") {
    date = new Date(date);
  }
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(
      RegExp.$1,
      (date.getFullYear() + "").substr(4 - RegExp.$1.length)
    );
  }
  let o = {
    "M+": date.getMonth() + 1,
    "d+": date.getDate(),
    "h+": date.getHours(),
    "m+": date.getMinutes(),
    "s+": date.getSeconds(),
  };
  for (let k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      let str = o[k] + "";
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length === 1 ? str : padLeftZero(str)
      );
    }
  }
  return fmt;
};

function padLeftZero (str) {
  return ("00" + str).substr(str.length);
}
/**
 * 在数组中根据名称查找内容
 * @param {*} paramName  参数名称
 * @param {*} isJson 是否json类型
 */
export function findDataByParam (paramName, isJson, data) {
  let obj = data.find((obj) => {
    return obj.param == paramName;
  });
  if (obj) {
    if (isJson == false) {
      if (obj.value) {
        return obj.value.replace(/(\s*$)/g, "");
      } else {
        return "";
      }
    } else {
      return JSON.parse(obj.value);
    }
  } else {
    return "";
  }
}
/**
 * //拿取匹配的时间段
 * @param {*} fromDate 开始时间
 * @param {*} toDate 结束时间
 * @param {*} dateType 时间类型
 */
export function getMatchTime (fromDate, toDate, dateType, ishour) {
  let vm = this;
  let timeData = [];
  if (typeof (fromDate) == "string") {
    let newStart = fromDate
    fromDate = newStart;
  }
  if (typeof (toDate) == "string") {
    let newEnd = toDate
    toDate = newEnd;
  }
  let differ = new Date(toDate).getTime() - new Date(fromDate).getTime();
  let sDate = fromDate
  if (differ / (24 * 3600 * 1000) <= 3) {
    if (ishour == true) {
      //三天内
      timeData = [];
      sDate = fromDate
      for (let i = 0; i <= differ; i += 3600 * 1000) {
        let differDate = new Date(sDate.getTime() + i);
        timeData.push({
          time: dateTool.format(differDate, "yyyy-MM-dd hh"),
          value: "",
        });
      }
    } else {
      //三天内
      timeData = [];
      sDate = fromDate
      for (let i = 0; i <= differ; i += 3600 * 1000) {
        let differDate = new Date(new Date(sDate).getTime() + i);
        timeData.push({
          time: dateTool.format(differDate, "yyyy-MM-dd hh:mm:ss"),
          value: "",
        });
      }
    }
  } else {
    timeData = [];
    if (dateType == "5") {
      for (let k = 0; k < 12; k++) {
        let thisDate = new Date(fromDate);
        thisDate.setMonth(k);
        let time = new Date(thisDate);
        timeData.push({
          time: dateTool.format(time, "yyyy-MM") + "/01 00:00:00",
          value: "",
        });
      }
    } else {
      for (let i = 0; i <= differ; i += 3600 * 1000 * 24) {
        //大于三天  手动拼装time，最后与拿到的time值进行匹配
        let differDate = new Date(new Date(sDate).getTime() + i);
        timeData.push({
          time: dateTool.format(differDate, "yyyy-MM-dd ") + "00:00:00",
          value: "",
        });
      }
    }
  }
  return timeData;
}

/**
 * 获取分页数据
 * @param {*} data 数据源
 * @param {*} index 索引
 * @param {*} size 分页大小
 */
export const getPage = function (data, index, size) {
  let startIndex = (index - 1) * size;
  let endIndex = index * size;
  let page = {
    data: data.slice(startIndex, endIndex),
    total: data.length,
    pageIndex: index,
    pageSize: size,
  };
  return page;
};


/**
 * 生成分页的参数
 * @param {*} arr
 * @param {*} index
 * @param {*} size
 */
export function toPage (arr, index, size) {
  let start = 0;
  if (index != 1) start = (index - 1) * size;
  let end = index * size;
  return {
    pageIndex: index,
    pageSize: size,
    total: arr.length,
    arr: arr.slice(start, end),
  };
}

/**
 * 根据状态转换时间
 * @param {*} type
 */
export function dateToColumns (type, startDate, endDate, align) {
  let arr = [];
  let item = {};
  let arrDate = [];
  let i = 0;
  if (typeof (startDate) == "string") {
    let newStart = startDate
    startDate = newStart;
  }
  if (typeof (endDate) == "string") {
    let newEnd = endDate
    endDate = newEnd;
  }
  switch (type) {
    //转成小时
    case "day":
      for (i = 0; i < 24; i++) {
        item = {
          //为什么要写+""，因为表格的类型是str
          prop: i + "",
          label: i + "时",
          width: 110,
          show: true,
          align: align ? align : "center",
        };
        arr.push(item);
      }
      break;
    case "timeInterval":
      break;
    case "month":
      arrDate = getDuration("day", startDate, endDate);
      for (i = 0; i < arrDate.length - 1; i++) {
        item = {
          prop: arrDate[i].toLocaleDateString(),
          label: dateTool.format(arrDate[i], "MM/dd"),
          show: true,
          width: 150,
          align: align ? align : "center",
        };
        arr.push(item);
      }
      break;
    case "year":
      for (i = 1; i <= 12; i++) {
        item = {
          prop: i + "",
          label: i + "月",
          show: true,
          width: 150,
          align: align ? align : "center",
        };
        arr.push(item);
      }
      break;
    default:
      break;
  }
  return arr;
}
/**
 * 根据表格dom id导出excel
 * @param {*} id  表格id
 * @param {*} name  excel文件名称
 * @param {*} elem 导出时间
 */
export function exportExcel (id, name, elem) {
  let date = null
  let raw = false;

  MessageBox.confirm("是否按excel格式导出？", "系统提示", {
    showCancelButton: true,
    confirmButtonText: '是',
    cancelButtonText: '否',
    callback: (action, instance) => {
      if (action == "confirm") {
        raw = false;
      } else {
        raw = true;
        return
      }

      if (elem) {
        if (elem.dateType == 'day') {
          name += dateTool.format(new Date(elem.startTime), "yyyy年MM月dd日");
        } else if (elem.dateType == 'month') {
          name += dateTool.format(new Date(elem.startTime), "yyyy年MM月");
        } else if (elem.dateType == 'year') {
          name += dateTool.format(new Date(elem.startTime), "yyyy年");
        } else if (elem.dateType == 'timeInterval') {
          name += dateTool.format((new Date(elem.startTime)), "yyyy-MM-dd hh:mm:ss");
          
        } else {
          name += dateTool.format((new Date(elem)), "yyyy-MM-dd hh:mm:ss");
          
        }
      }
      let fix = document.querySelector(".el-table__fixed");
      let wb;
      var xlsxParam = {
        raw: raw,
      }; //转换成excel时，使用原始的格式
      if (fix) {
        //判断要导出的节点中是否有fixed的表格，如果有，转换excel时先将该dom移除，然后append回去
        wb = XLSX.utils.table_to_book(
          document.querySelector("#" + id).removeChild(fix),
          xlsxParam
        );
        document.querySelector("#" + id).appendChild(fix);
      } else {
        wb = XLSX.utils.table_to_book(document.querySelector("#" + id), xlsxParam);
      }
      var wbout = XLSX.write(wb, {
        bookType: "xlsx",
        bookSST: true,
        type: "array",
      });
      try {
        FileSaver.saveAs(
          new Blob([wbout], {
            type: "application/octet-stream",
          }),
          name + ".xlsx"
        );
      } catch (e) {
        if (typeof console !== "undefined");
      }
      return wbout;
    }
  })
}

function getDuration (type, start, stop) {
  var $array = new Array();
  var current = new Date(start);
  stop = new Date(stop);
  while (current <= stop) {
    $array.push(new Date(current));
    if (type == "hour") {
      //小时
      current.setHours(current.getHours() + 1);
    } else if (type == "day") {
      //天
      current.setDate(current.getDate() + 1);
    } else if (type == "week") {
      //周
      current.setDate(current.getDate() + 7);
    } else if (type == "month") {
      //月
      current.setMonth(current.getMonth() + 1);
    } else {
      //默认天
      current.setDate(current.getDate() + 1);
    }
  }
  return $array;
}
/**
 * 数组转树结构数据  //表格树专用
 * @param {*} data
 * @param {*} pId
 * @param {*} setSort 设置层级
 * @param {*} lastSort 上一级的层级
 */
export function arrToTreeDataLh (data, pId, setSort, lastSort) {
  let arr = [];
  for (var i = 0; i < data.length; i++) {
    let item = data[i]
    if (item.parentId == pId) {
      item.sort = 0;
      if (setSort == true) {
        item.sort = lastSort + 1;
      }
      item.children = arrToTreeDataLh(data, item.id, setSort, item.sort);
      item.name = item.children.length > 0 ? "|-- " + item.name : "  |-- " + item.name;
      arr.push(item);
    }
  }
  return arr;
}
/**
 * 数组转树结构数据
 * @param {*} data
 * @param {*} pId
 * @param {*} isReturn //是否是投退分析的界面专用
 */
let index = 1;
export function creatTreeData (data, pId, isReturn) {
  let arr = [];
  if (isReturn) {
    for (var j in data) {
      if (data[j].parentId == pId) {
        let item = {};
        item.id = data[j].id;
        item.disabled = data[j].measureId == "-1";
        item.parentId = data[j].parentId;
        item.label = data[j].measureName;
        item.index = index;
        index++;
        item.children = creatTreeData(data, data[j].id, true);
        arr.push(item);
      }
    }
  } else {
    for (var i in data) {
      if (data[i].parentId == pId) {
        let item = {};
        item.pid = data[i].id;
        item.id = data[i].measureId;
        item.disabled = data[i].measureId == "-1";
        item.parentId = data[i].parentId;
        item.label = data[i].measureName;
        item.index = index;
        index++;
        item.children = creatTreeData(data, data[i].id);
        arr.push(item);
      }
    }
  }
  return arr;
}
/**
 * 递归获取部门的名称
 * @param {*} pid
 * @param {*} orsData
 */
export function getMountedOnName (pid, orsData) {
  let str = "";
  let item = orsData.find((obj) => obj.id == pid);
  if (item) {
    str += "/" + item.name;
    str += getMountedOnName(item.parentId, orsData);
  }
  return str;
}
/**
 * 数组去重
 * @param {*} arr
 */
export function unique (arr) {
  let result = [];
  let obj = {};
  for (var i = 0; i < arr.length; i++) {
    if (!obj[arr[i].code]) {
      result.push(arr[i]);
      obj[arr[i].code] = true;
    }
  }
  return result;
}
/**
 * 生成菜单树数据
 * @param {*} data  数据
 * @param {*} fid
 */
export function creatMenuJson (data, fid) {
  let arr = [];
  for (let i = 0; i < data.length; i++) {
    if (data[i].parentId == fid) {
      let item = {};
      item = data[i];
      item.children = creatMenuJson(data, data[i].id);
      if (item.children.length > 0) {
        item.component = fid == 0 ? "Layout" : "none";
      }
      arr.push(item);
    }
  }
  return arr;
}
/**
 * 数组转树结构数据
 * @param {*} data
 * @param {*} pId
 * @param {*} setSort 设置层级
 * @param {*} lastSort 上一级的层级
 */
export function arrToTreeData (data, pId, setSort, lastSort) {
  let arr = [];
  for (var i in data) {
    if (data[i].parentId == pId) {
      let item = data[i];
      item.sort = 0;
      if (setSort == true) {
        item.sort = lastSort + 1;
      }
      item.children = arrToTreeData(data, data[i].id, setSort, item.sort);
      arr.push(item);
    }
  }
  return arr;
}

/**
 * 不改字段名称
 * @param {*} data
 * @param {*} pId
 */
export function creatArentTreeData (data, pId) {
  let arr = [];
  data.forEach((val, index) => {
    if (val.parentId == pId) {
      let item = {};
      item = val;
      item.children = creatArentTreeData(data, item.id);
      arr.push(item);
    }
  });
  return arr;
}
/**
 * 时间戳转化为年 月 日 时 分 秒
 * number: 传入时间戳
 * format：返回格式，支持自定义，但参数必须与formateArr里保持一致
 * formatTime(sjc,'Y-M-D h:m:s'));//转换为日期：2017-03-03 03:03:03
 * formatTime(sjc, 'h:m'));//转换为日期：03:03
 */
export function formatTime (number, format) {
  var formateArr = ["Y", "M", "D", "h", "m", "s"];
  var returnArr = [];

  var date = new Date(number * 1000);
  returnArr.push(date.getFullYear());
  returnArr.push(formatNumber(date.getMonth() + 1));
  returnArr.push(formatNumber(date.getDate()));
  returnArr.push(formatNumber(date.getHours()));
  returnArr.push(formatNumber(date.getMinutes()));
  returnArr.push(formatNumber(date.getSeconds()));

  for (var i in returnArr) {
    format = format.replace(formateArr[i], returnArr[i]);
  }
  return format;
}
//数据转化
export function formatNumber (n) {
  n = n.toString();
  return n[1] ? n : "0" + n;
}

/**
 * @msg: 获取今日数据时间和昨日数据
 *
 * @paramd {number} dataType 0日，1月，2年
 * @return: string 数组，0是今的开始时间，1是今的结束时间，2是昨的开始时间，3是昨的结束时间
 */
export function getTime (dataType) {
  let time = [];
  let y = getDate("yyyy");
  let m = getDate("MM");
  let d = getDate("dd");
  let h = getDate("HH");
  if (dataType == 0) {
    let sd = parseFloat(d) - 1;
    if (m == 1 || m == 3 || m == 5 || m == 7 || m == 8 || m == 10 || m == 12) {
      if (d == 1) {
        sd = 31;
      } else {
        sd = parseFloat(d) - 1;
        if (sd < 10) {
          sd = "0" + sd;
        }
      }
    } else {
      if (d == 1) {
        d = 30;
      } else {
        sd = parseFloat(d) - 1;
        if (sd < 10) {
          sd = "0" + sd;
        }
      }
    }
    time = [
      y + "-" + m + "-" + d + " " + "00:00:00",
      y + "-" + m + "-" + d + " " + "23:59:59",
      y + "-" + m + "-" + sd + " " + "00:00:00",
      y + "-" + m + "-" + sd + " " + "23:59:59",
    ];
  } else if (dataType == 1) {
    let sm = parseFloat(m) - 1;
    if (m == 1) {
      sm = 12;
    } else {
      sm = parseFloat(m) - 1;
    }
    time = [
      y + "-" + m + "-" + d,
      y + "-" + m + "-" + d,
      y + "-" + sm + "-" + d,
      y + "-" + sm + "-" + d,
    ];
  } else {
    let sy = parseFloat(y) - 1;
    time = [y + "-" + m, y + "-" + m, sy + "-" + m, sy + "-" + m];
  }
  return time;
}

/**
 * @msg: 获取系统当前时间
 * @param {string} fmt 时间格式 具体看代码
 * @return: string
 */
export const getDate = (fmt) => {
  let time = "";
  const date = new Date();
  const o = {
    "M+": date.getMonth() + 1, // 月份
    "d+": date.getDate(), // 日
    "H+": date.getHours(), // 小时
    "m+": date.getMinutes(), // 分
    "s+": date.getSeconds(), // 秒
    "q+": Math.floor((date.getMonth() + 3) / 3), // 季度
    S: date.getMilliseconds(), // 毫秒
  };
  if (/(y+)/.test(fmt)) {
    time = fmt.replace(
      RegExp.$1,
      (date.getFullYear() + "").substr(4 - RegExp.$1.length)
    );
  }
  for (const k in o) {
    if (new RegExp("(" + k + ")").test(fmt)) {
      time = fmt.replace(
        RegExp.$1,
        RegExp.$1.length === 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length)
      );
    }
  }
  return time;
};

/**
 * @msg：根据时间类型获取动态的年月周日的x周
 * @param {*}： timeData传入的数据 ，index索引，1是时，2是日，3是周，4是月，5是年
 */
export function getX (timeData1, index, ismonth) {
  let mee = []; //月
  let yee = []; //年
  let wee = []; //周
  let dee = []; //日
  let hee = []; //时
  let arr = [];
  let timeData = JSON.parse(JSON.stringify(timeData1));
  let timee;
  if (index == 5) {
    for (let i = 0; i < timeData.length; i++) {
      timee = Date.parse(timeData[i].time) / 1000;
      yee.push(formatTime(timee, "Y"));
      arr.push(formatTime(timee, "Y"));
    }
    // arr=arr.concat(yee)
    for (let i = 0; i < yee.length; i++) {
      timeData[i].time = yee[i];
    }
  } else if (index == 4) {
    for (let i = 0; i < timeData.length; i++) {
      timee = Date.parse(timeData[i].time) / 1000;
      mee.push(formatTime(timee, "Y-M-D"));
      arr.push(formatTime(timee, "M"));
      //   timeData.push(formatTime(timee, "M"));
    }
    // arr = arr.concat(mee);
    if (ismonth == true) {
      for (let i = 0; i < arr.length; i++) {
        switch (arr[i]) {
          case "01":
            // mee[i].month = "Jan";
            timeData[i].time = "Jan";
            break;
          case "02":
            // mee[i].month = "Feb";
            timeData[i].time = "Feb";
            break;
          case "03":
            // mee[i].month = "Mar";
            timeData[i].time = "Mar";
            break;
          case "04":
            // mee[i].month = "Apr";
            timeData[i].time = "Apr";
            break;
          case "05":
            // mee[i].month = "May";
            timeData[i].time = "May";
            break;
          case "06":
            // mee[i].month = "Jun";
            timeData[i].time = "Jun";
            break;
          case "07":
            // mee[i].month = "Jul";
            timeData[i].time = "Jul";
            break;
          case "08":
            // mee[i].month = "Aug";
            timeData[i].time = "Aug";
            break;
          case "09":
            // mee[i].month = "Sep";
            timeData[i].time = "Sep";
            break;
          case "10":
            // mee[i].month = "Oct";
            timeData[i].time = "Oct";
            break;
          case "11":
            // mee[i].month = "Nov";
            timeData[i].time = "Nov";
            break;
          case "12":
            // mee[i].month = "Dec";
            timeData[i].time = "Dec";
            break;
        }

        // timeData[i].time = mee[i];
      }
    } else {
      for (let i = 0; i < arr.length; i++) {
        timeData[i].time = mee[i];
      }
    }
  } else if (index == 3) {
    for (let j = 0; j < timeData.length; j++) {
      wee.push('w' + getWeekOfYear(timeData[j].time));
      timeData[j].time = 'w' + getWeekOfYear(timeData[j].time);
    }
    timeData = (addWeek(timeData))
  } else if (index == 2) {
    for (let i = 0; i < timeData.length; i++) {
      timee = Date.parse(timeData[i].time) / 1000;
      dee.push(formatTime(timee, "M.D"));
    }
    for (let i = 0; i < dee.length; i++) {
      timeData[i].time = dee[i];
      for (let i = 0; i < dee.length; i++) {
        timeData[i].time = dee[i];
      }
    }
  } else if (index == 1) {
    for (let i = 0; i < timeData.length; i++) {
      timee = Date.parse(timeData[i].time) / 1000;
      hee.push(formatTime(timee, "h") + "时");
    }
    arr = arr.concat(hee);
    for (let i = 0; i < hee.length; i++) {
      timeData[i].time = hee[i];
    }
  }
  return timeData;
}
/**
 * @params{*}  相同周累计
 * @weekData  //传入的周数据
 */
export function addWeek (weekData) {
  let data = JSON.parse(JSON.stringify(weekData))
  let result = {}
  for (let j = 0; j < data.length; j++) {
    if (result[data[j].time]) {
      result[data[j].time] += data[j].value;
    } else {
      result[data[j].time] = data[j].value;
    }
  }
  var keyvalue = [];
  for (var key in result) {
    keyvalue.push({
      time: key,
      value: result[key]
    })
  }
  return keyvalue
}
/**
 * @msg:获取当前是第几周
 * @curTime  传入的时间
 * @param {*}
 */
export function getWeekOfYear (curTime) {
  var today = new Date(curTime);
  var firstDay = new Date(today.getFullYear(), 0, 1);
  var dayOfWeek = firstDay.getDay();
  var spendDay = 1;
  if (dayOfWeek != 0) {
    // spendDay = 7 - dayOfWeek + 1;
    spendDay = 7 - dayOfWeek;
  }
  firstDay = new Date(today.getFullYear(), 0, 1 + spendDay);
  var d = Math.ceil((today.valueOf() - firstDay.valueOf()) / 86400000);
  var result = Math.ceil(d / 7);
  return result + 1;
}
/**
 *
 * @param {*} 获取x轴
 * @param {*}
 */
export function getxData () {
  let timex = [];
  let newtime = new Date().getTime();
  let newyear = formatDate(new Date(newtime), "yyyy");
  let lastyear = newyear - 1;
  let yearx = [String(lastyear), newyear];
  let newmouth = formatDate(new Date(newtime), "MM");
  let mouthx = [];
  let newTime = formatDate((new Date().setMonth(new Date().getMonth())), 'MM-') + '01'
  mouthx.push(getMouth_(formatDate(new Date(newTime).setMonth(new Date(newTime).getMonth() - 4), 'MM') + '-01'))
  newTime = formatDate((new Date().setMonth(new Date().getMonth())), 'MM-') + '01'
  mouthx.push(getMouth_(formatDate(new Date(newTime).setMonth(new Date(newTime).getMonth() - 3), 'MM') + '-01'))
  newTime = formatDate((new Date().setMonth(new Date().getMonth())), 'MM-') + '01'
  mouthx.push(getMouth_(formatDate(new Date(newTime).setMonth(new Date(newTime).getMonth() - 2), 'MM') + '-01'))
  newTime = formatDate((new Date().setMonth(new Date().getMonth())), 'MM-') + '01'
  mouthx.push(getMouth_(formatDate(new Date(newTime).setMonth(new Date(newTime).getMonth() - 1), 'MM') + '-01'))
  newTime = formatDate((new Date().setMonth(new Date().getMonth())), 'MM-') + '01'
  mouthx.push(getMouth_(formatDate(new Date(newTime).setMonth(new Date(newTime).getMonth()), 'MM') + '-01'))
  let weekx = [];
  for (let i = 0; i < 5; i++) {
    let item = new Date().getTime() - 7 * (4 - i - 2) * 3600 * 24 * 1000;
    weekx.push(getWeek_(formatDate(new Date(item), "yyyy-MM-dd")));
  }
  let dayx = [];
  for (let i = 0; i < 7; i++) {
    let item = new Date().getTime() - (6 - i) * 3600 * 24 * 1000;
    dayx.push(formatDate(new Date(item), "MM.dd"));
  }
  timex = [...yearx, ...mouthx, ...weekx, ...dayx];
  return timex;
}
/**
 *
 * @param {*} _arr
 * @param {*} data  时间 月
 */
export function getMouth_ (date) {
  let week;
  switch (date) {
    case "01-01":
      week = "Jan";
      break;
    case "02-01":
      week = "Feb";
      break;
    case "03-01":
      week = "Mar";
      break;
    case "04-01":
      week = "Apr";
      break;
    case "05-01":
      week = "May";
      break;
    case "06-01":
      week = "Jun";
      break;
    case "07-01":
      week = "Jul";
      break;
    case "08-01":
      week = "Aug";
      break;
    case "09-01":
      week = "Sep";
      break;
    case "10-01":
      week = "Oct";
      break;
    case "11-01":
      week = "Nov";
      break;
    case "12-01":
      week = "Dec";
      break;
    default:
      return "";
  }
  return week;
}
/**
 *
 * @param {*} 获取周
 * @param {*} dt
 */
export function getWeek_ (dt) {
  let d1 = new Date(dt);
  let d2 = new Date(dt);
  d2.setMonth(0);
  d2.setDate(1);
  let rq = d1 - d2;
  let days = Math.ceil(rq / (24 * 60 * 60 * 1000));
  let num = Math.ceil(days / 7) - 1;
  return "w" + num;
}
